import { actions } from "./Reducer";

/**
 * Actions that fire saga watchers
 */
export const getMySingleProductSupplierAction = (id) => ({
	type: actions.GET_MY_SUPPLIER_PRODUCT,
	payload: id,
});

export const getMyProductsSuppliersAction = (body) => ({
	type: actions.GET_MY_SUPPLIER_PRODUCTS,
	payload: body,
});

export const createMySupplierProductAction = (formData) => ({
	type: actions.CREATE_MY_SUPPLIER_PRODUCT,
	payload: formData,
});

export const updateMySupplierProductAction = (id, formData) => ({
	type: actions.UPDATE_MY_SUPPLIER_PRODUCT,
	payload: {
		formData,
		id,
	},
});

// export const addEditorReviewSupplierProduct = (id,formData) => ({
//   type: actions.ADD_EDITOR_REVIEW_SUPPLIER_PRODUCT,
//   payload: {
//     formData,
//     id,
//   }
// })

export const getMyProductsSupplierPictures = () => ({
	type: actions.GET_MY_SUPPLIER_PRODUCTS_PICTURES,
});

/**
 * Actions that are fired by redux-saga watchers
 */

export const getMyProductSupplierSuccessAction = (product) => ({
	type: actions.GET_MY_SUPPLIER_PRODUCT_SUCCESS,
	payload: product,
});

export const getMyProductsSupplierSuccessAction = (products) => ({
	type: actions.GET_MY_SUPPLIER_PRODUCTS_SUCCESS,
	payload: products,
});

export const createMySupplierProductSuccessAction = (product) => ({
	type: actions.CREATE_MY_SUPPLIER_PRODUCT_SUCCESS,
	payload: product,
});

export const updateMySupplierProductSuccessAction = (product) => ({
	type: actions.UPDATE_MY_SUPPLIER_PRODUCT_SUCCESS,
	payload: product,
});

export const getMyProductsSupplierPicturesSuccess = (productsPictures) => ({
	type: actions.GET_MY_SUPPLIER_PRODUCTS_PICTURES_SUCCESS,
	payload: productsPictures,
});

/**
 * Misc
 */

export const setSupplierProductsIsLoadingAction = (payload) => ({
	type: actions.SET_SUPPLIER_PRODUCTS_IS_LOADING,
	payload,
});

export const setSupplierProductsCountAction = (count) => ({
	type: actions.SET_SUPPLIER_PRODUCTS_COUNT,
	payload: count,
});

export const setSearchValueAction = (value) => ({
	type: actions.SET_AP_SEARCH_VALUE,
	payload: value,
});
